import angular from 'angular';
import { FeatureSupport } from './feature-support';
import { detectModule } from 'go-modules/detect';

export const featureSupportModule = angular.module('featureSupportModule', [
	detectModule
])
	.service('featureSupport', FeatureSupport)
	.name;
